import React from 'react';
import { ObservableField as Field, useForm } from '../../ObservableForm';
import TextList from './TextList';
import { MultiInputFieldFragment } from './MultiInputField.generated';
import { FormatAndLinkify } from '@99designs/spa-common';
import { NinedownText } from '../../NinedownText';
import styled from 'styled-components';

export type Props = MultiInputFieldFragment;

export function Edit({ id: name, label, placeholder }: Props) {
    const form = useForm();
    const { onChange } = form.attach(name);

    return (
        <Field
            form={form}
            name={name}
            title={label}
            render={() => (
                <TextList
                    value={form.get(name) ?? []}
                    onChange={onChange}
                    placeholder={placeholder ?? ''}
                />
            )}
        />
    );
}

const List = styled.ul`
    margin-bottom: 0;
`;

export function View({ multiInputValue: urls }: Props) {
    return (
        <List>
            {urls.map((url) => (
                <li key={url}>
                    <NinedownText>
                        <FormatAndLinkify rawHtml={url} />
                    </NinedownText>
                </li>
            ))}
        </List>
    );
}

export function HasValue({ multiInputValue }: Props): boolean {
    return multiInputValue.length !== 0;
}

export function getValue({ multiInputValue }: Props) {
    return multiInputValue;
}
